import React, { Component } from "react";
import { TabMenu } from "primereact/tabmenu";
import { Route, Routes, useLocation, useNavigate, useParams, Navigate } from "react-router-dom";
import "primeflex/primeflex.css";
import "../../style/news.css";
import { Toast } from 'primereact/toast';
import NewsPage from "./News.page";
import Advertising from "./Advertising";
import Version from "./Version";

class News extends Component {
  constructor(props) {
    super(props);
    this.menuItems = [
      {
        label: "News",
        path: "",
        command: function () {
          props.router.navigate(this.path);
        },
      },
      {
        label: "Advertising",
        path: "advertising",
        command: function () {
          props.router.navigate(this.path);
        },
      },
      {
        label: "Version",
        path: "version",
        command: function () {
          props.router.navigate(this.path);
        },
      },
    ]
    this.state = {
      selectedMenuItem: 0
    };
    this.onTabChangeHandler = this.onTabChangeHandler.bind(this);
  }

  onTabChangeHandler(event) {
    this.setState({
      selectedMenuItem: event.index
    })
  }

  componentDidMount() {
    let SPLIT_PATH = this.props.router.location.pathname.split("/");
    let path = SPLIT_PATH[SPLIT_PATH.length - 1];
    this.setState({
        selectedMenuItem: ["news", "*"].includes(path)  ? 0 : this.menuItems.findIndex(val => val.path === path)
      })
  }

  render() {

    return (
      <div className="main-box">
        <Toast ref={(el) => this.toast = el} baseZIndex={20000} />
        
          
        <div className="app__grid">
        <TabMenu
            model={this.menuItems}
            activeIndex={this.state.selectedMenuItem}
            id='mi__tab__menu'
            className='mb-2'
            onTabChange={this.onTabChangeHandler}
          />
        <Routes>
            <Route index element={<NewsPage />}></Route>
            <Route path="advertising" element={<Advertising />}></Route>
            <Route path="version" element={<Version />}></Route>
            <Route path='*' element={<Navigate to='' replace />} />
          </Routes>

        </div>
      </div>
    );
  }
}

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
    return (
      <Component
        {...props}
        router={{ location, navigate, params }}
      />
    );
  }

  return ComponentWithRouterProp;
}
export default withRouter(News);
